module.exports = __webpack_public_path__ + "static/media/carousel-poster.dc31657d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/posterImgs/carousel-poster.jpg
// module id = 416
// module chunks = 0